document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-sp-workflow-approver]");
  if (!root) return;

  const dropdown = root.querySelector("[data-sp-workflow-dropdown]");
  const dropdownToggle = root.querySelector("[data-sp-workflow-dropdown-toggle]");
  const dropdownMenu = root.querySelector("[data-sp-workflow-dropdown-menu]");
  const toggleAllButton = root.querySelector("[data-sp-workflow-toggle-all]");
  const bulkApproveButton = root.querySelector("[data-sp-workflow-bulk-approve]");
  const bulkRejectButton = root.querySelector("[data-sp-workflow-bulk-reject]");

  function checkboxes() {
    return Array.from(root.querySelectorAll(".sp-workflow-approver__checkbox"));
  }

  function checkedCheckboxes() {
    return checkboxes().filter((checkbox) => checkbox.checked);
  }

  function updateToggleAllButton() {
    if (!toggleAllButton) return;

    const allCheckboxes = checkboxes();
    if (allCheckboxes.length === 0) {
      toggleAllButton.textContent = "一括選択";
      return;
    }

    toggleAllButton.textContent = allCheckboxes.every((checkbox) => checkbox.checked) ? "選択解除" : "一括選択";
  }

  function submitBulkAction(url, confirmMessage, missingSelectionMessage) {
    const selected = checkedCheckboxes();
    if (selected.length === 0) {
      alert(missingSelectionMessage);
      return;
    }
    if (!confirm(confirmMessage)) return;

    const params = new URLSearchParams();
    selected.forEach((checkbox) => {
      params.append("approvals[][id]", checkbox.value);
      params.append("approvals[][step_number]", checkbox.dataset.stepNumber || "");
    });

    Spinner.show();

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: params
    })
      .then((response) => {
        if (response.ok) {
          window.location.reload();
          return null;
        }

        return response.text().then((text) => {
          Spinner.hide();
          try {
            const payload = JSON.parse(text);
            alert(payload.error || "処理に失敗しました。");
          } catch (_error) {
            alert("処理に失敗しました。");
          }
          return null;
        });
      })
      .catch(() => {
        Spinner.hide();
        alert("処理に失敗しました。");
      });
  }

  if (dropdown && dropdownToggle && dropdownMenu) {
    dropdownToggle.addEventListener("click", () => {
      const isExpanded = dropdownToggle.getAttribute("aria-expanded") === "true";
      dropdownToggle.setAttribute("aria-expanded", String(!isExpanded));
      dropdownMenu.hidden = isExpanded;
    });

    document.addEventListener("click", (event) => {
      if (dropdown.contains(event.target)) return;

      dropdownToggle.setAttribute("aria-expanded", "false");
      dropdownMenu.hidden = true;
    });
  }

  if (toggleAllButton) {
    toggleAllButton.addEventListener("click", () => {
      const allCheckboxes = checkboxes();
      if (allCheckboxes.length === 0) return;

      const shouldCheck = !allCheckboxes.every((checkbox) => checkbox.checked);
      allCheckboxes.forEach((checkbox) => {
        checkbox.checked = shouldCheck;
      });
      updateToggleAllButton();
    });
  }

  checkboxes().forEach((checkbox) => {
    checkbox.addEventListener("change", updateToggleAllButton);
  });

  if (bulkApproveButton) {
    bulkApproveButton.addEventListener("click", () => {
      submitBulkAction(
        root.dataset.bulkApproveUrl,
        root.dataset.bulkApproveConfirm,
        "承認する申請を選択してください。"
      );
    });
  }

  if (bulkRejectButton) {
    bulkRejectButton.addEventListener("click", () => {
      submitBulkAction(
        root.dataset.bulkRejectUrl,
        root.dataset.bulkRejectConfirm,
        "否認する申請を選択してください。"
      );
    });
  }

  updateToggleAllButton();
});
